import NProgress from 'nprogress'
import { useTimeoutFn } from '@vueuse/core'

export default function () {
  const { start, stop } = useTimeoutFn(() => NProgress.start(), 250, { immediate: false })

  router.on('start', () => {
    stop()
    start()
  })

  router.on('progress', (event) => {
    if (NProgress.isStarted() && event.detail.progress.percentage) {
      NProgress.set((event.detail.progress.percentage / 100) * 0.9)
    }
  })

  router.on('finish', (event) => {
    stop()
    if (!NProgress.isStarted()) {
      return
    } else if (event.detail.visit.completed) {
      NProgress.done()
    } else if (event.detail.visit.interrupted) {
      NProgress.set(0)
    } else if (event.detail.visit.cancelled) {
      NProgress.done()
      NProgress.remove()
    }
  })
}
